import selectedOptionStyles from "components/select/partial/selcted-styles.css.js";

export default theme => ({
  select_formcontrol: {
    width: "100%",
  },
  select_dense: {
    paddingTop: 20,
  },
  ...selectedOptionStyles,
});
